import * as PurchaseActions from './actions';

const initialState = {
  doingPurchaseDeal: false
}

const purchaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case PurchaseActions.COMMITTED_PURCHASE_DEAL: {
      return {
        ...state,
        doingPurchaseDeal: action.doingPurchaseDeal
      }
    }
    default: {
      return state;
    }
  }
}

export default purchaseReducer;
